<template>
    <div class="field">
			<div class="field_description__wrapper">
					<label :class="isFieldRequired || isRequired ? 'req' : ''" v-html="label"></label>
					<p class="field_description" v-if="description">{{ description }}</p>
			</div>
			<div class="choise_wrapper">
					<div v-for="(value,key) in values" :key="key" @click="onItemClick(value.value)" class="choise_item" :class="modelValue === value.value ? 'active' : ''">
							{{ value.label }}
					</div>
			</div>
		</div>
</template>

<script>
export default {
  name: "BaseChoiseSelect.vue",
  inheritAttrs: false,
  data() {
    return {}
  },
  mounted() {},
  props: [
    'label',
    'modelValue',
		'values',
    'description',
    'isRequired'
  ],
  methods: {
    onItemClick(value) {
      this.$emit('update:modelValue', value);
      this.$emit('onChange', value);
		}
	},
  computed: {
    isFieldRequired() {
      if (this.objectKey) {
        return this.$parent.isFieldRequired(this.objectKey);
      }
      return false;
    },
    isFieldHasError() {
      return !!(this.isFieldRequired && this.isFormSubmitted && (this.modelValue === undefined || this.modelValue.length === 0));
    }
  }

}
</script>

<style scoped>
.field_label {
    margin-bottom: 15px;
}

.field_description {
    font-size: 16px;
    color: rgba(34, 34, 34, 0.5);
}
.choise_wrapper {
    border-radius: 4px;
    background: #F1EDE7;
    height: 50px;
		display: inline-flex;
		overflow: hidden;
    border: 1px solid #EFA24F;
}
.choise_item {
    height: 100%;
		padding: 20px;
		display: flex;
		background: #fff;
    align-items: center;
		justify-content: center;
		cursor: pointer;
}
.choise_item:not(:last-child) {
    border-right: 1px solid #EFA24F;
}
.choise_item.active {
    background: linear-gradient(92deg, #F7C100 0.01%, #F69400 100%);
		color: #fff;
}
@media (max-width: 1000px) {
	.choise_item:not(:last-child) {
      border-bottom: 1px solid #efa24f;
	}
}
</style>